'use strict';
module.exports = require('./AccordionTab.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/accordiontab/index.js
// module id = 1522
// module chunks = 1